export enum Routes {
  LOGIN = 'login',
  NEW_PASSWORD = 'new-password',
  FINISH_ACCOUNT = 'finish-account',
  CONFIRM_DATA = 'confirm-data',
  ONBOARDING = 'onboarding',
}
